module.exports = __webpack_public_path__ + "static/media/students-img2.7f9f41ef.svg";